import { animated, useSpring } from "react-spring";
import { colors } from "../../../constants/constants";
import { springConfigs } from "../../../constants/springConfigs";
import { useWindowSize } from "../../../hooks/useWindowSize";

export const SVGCircle = ({
  active,
  svgComponent,
  style,
  containerStyle,
  appearSlideUp = true,
}: {
  active: any;
  svgComponent: any;
  style?: any;
  containerStyle?: any;
  appearSlideUp?: boolean;
}) => {
  const { circleStrokeDashoffset } = useSpring({
    from: { circleStrokeDashoffset: 1 },
    to: { circleStrokeDashoffset: active ? 0.45 : 1 },
    config: {
      tension: 280,
      friction: 120,
      mass: 10,
    },
  });
  const { circleAppearHeight } = useSpring({
    from: { circleAppearHeight: appearSlideUp ? "0%" : "100%" },
    to: { circleAppearHeight: "100%" },
    config: springConfigs.outlineAppear,
  });
  const { mobileVertical, tabletVertical }: any = { ...useWindowSize() };

  return (
    <div
      style={{
        alignItems: "center",
        paddingTop: "2.25rem",
        paddingBottom: "2.25rem",
        height: "100%",
        display: "flex",
        ...containerStyle,
      }}
    >
      {/* relative */}
      <div
        style={{
          alignItems: "center",
          position: "relative",
          height: mobileVertical || tabletVertical ? "17vw" : "7vw",
          width: mobileVertical || tabletVertical ? "17vw" : "7vw",
          display: "flex",
          ...style,
        }}
      >
        {/* absolute */}
        <div
          {...{
            style: {
              width: "100%",
              height: "100%",
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
        >
          {svgComponent}
        </div>
        {/* absolute */}
        <animated.div
          style={{
            position: "absolute",
            width: "100%",
            height: circleAppearHeight,
            overflow: "hidden",
          }}
        >
          <svg viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke={colors.purple4}
              fill="transparent"
              strokeWidth={1}
              pathLength="1"
              strokeDasharray="1"
              strokeDashoffset={0}
            />
            {
              <animated.circle
                cx="50"
                cy="50"
                r="45"
                transform="rotate(110)"
                transform-origin="center"
                stroke={colors.pink}
                fill="transparent"
                strokeWidth={2}
                pathLength="1"
                strokeDasharray="1"
                strokeDashoffset={circleStrokeDashoffset}
                strokeLinecap="round"
              />
            }
          </svg>
        </animated.div>
      </div>
    </div>
  );
};
